import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import useComponentVisible from "../../../../../hooks/useComponentVisible";
import { NextIcon } from "../../Svg";

import {
  ChannelWrapper,
  ChannelMain,
  Wrapper,
  ChannelActions,
  PageLink,
  ChannelIcon
} from "../SideBarChannels.styled";

const JobPageTab = ({ setShowLeadForm, active, jobPageLink, clientView }) => {
  const { ref } = useComponentVisible(false);
  const onClick = useCallback(() => setShowLeadForm(true), [setShowLeadForm]);
  const { t } = useTranslation();

  return (
    <ChannelWrapper ref={ref}>
      <ChannelMain active={active} onClick={onClick}>
        <Wrapper>
          <ChannelIcon src={`/images/icons-channels/job-page.svg`} />
          {t("Job Page")}
        </Wrapper>
        <ChannelActions>
          {!clientView && (
            <PageLink
              href={jobPageLink}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              <NextIcon />
            </PageLink>
          )}
        </ChannelActions>
      </ChannelMain>
    </ChannelWrapper>
  );
};

export default JobPageTab;
